export default __webpack_public_path__ + "static/media/plantWatering.c92c5d1f.jpg";